import { render, staticRenderFns } from "./WorkOrderCards.vue?vue&type=template&id=2127607b&scoped=true"
import script from "./WorkOrderCards.vue?vue&type=script&lang=js"
export * from "./WorkOrderCards.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderCards.vue?vue&type=style&index=0&id=2127607b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2127607b",
  null
  
)

export default component.exports